import $api from "@/frontend/shared/api/axios";
import { convertStringWithAndSymbol } from "@/frontend/shared/lib/convertStringWithAndSymbol/convertStringWithAndSymbol";
import { ESectionOptions } from "@/frontend/widgets/Sidebar";

export async function postPortfolioCompanySectionNote({ content, id }: { content: string; id: number }) {
  // we moved from separate comments to unified comments
  // for now we consider all comments are overview comments for BE - A.
  const section = ESectionOptions.OVERVIEW;

  const sectionWithoutSpaces = convertStringWithAndSymbol(section);
  const response = await $api.post(`/portfolio-companies/${id}/notes`, { section: sectionWithoutSpaces, content });
  return response;
}
